const brandColors = {
  electricBlue: '#0071e3',
  hoverBlue: '#0e99ff',
  concordBlue: '#002f69',
  lightBlue: '#638bbf',
  lighterBlue: '#7ba7de',
  lightestBlue: '#d7e6f6',
  black: '#000',
  graphite: '#333',
  lightGraphite: '#555',
  smoke: '#888',
  lightSmoke: '#bbb',
  gray: '#ddd',
  lightGray: '#f2f2f2',
  silver: '#f9f9f9',
  white: '#fff',
  successGreen: '#199953',
  lightGreen: '#e8f7ed',
  darkYellow: '#ac6f0b',
  warningYellow: '#f5a623',
  lightYellow: '#fff3cd',
  warningRed: '#d0011b',
  lightRed: '#f7d5d9',
};

export default brandColors;
